import Choices from 'choices.js';

const dropdowns = Array.from(document.querySelectorAll('.js-choices-dropdown'));

const initDropdown = (dropdown) => {
    const shouldSort = !dropdown.dataset.customOrder;
    new Choices(dropdown, {
        searchEnabled: false,
        itemSelectText: '',
        shouldSort
    });
};

export default (() => {
    if (dropdowns) {
        dropdowns.forEach(dropdown => initDropdown(dropdown));
    }
})();
